export const MAX_ALTERNATIVE_GROUPS = 12;

interface AlternativeGroupMatch {
  grouping?: string;
  groups_matched?: string[];
}

interface AlternativeUuidMatch {
  groups_matched?: string[];
}

export function getUniqueAlternativeGroupsFromFound(
  found: Record<string, AlternativeGroupMatch[] | boolean> | null | undefined
): string[] {
  if (!found) return [];

  const groups = new Set<string>();

  Object.keys(found)
    .filter((key) => key !== 'account_holders')
    .forEach((key) => {
      const items = found[key];

      if (!Array.isArray(items)) return;

      items.forEach((item) => {
        const group = item.grouping || item.groups_matched?.[0];

        if (group) {
          groups.add(group);
        }
      });
    });

  return Array.from(groups);
}

export function getUniqueAlternativeGroupsFromUuids(
  uuids: AlternativeUuidMatch[] | null | undefined
): string[] {
  if (!uuids) return [];

  const groups = new Set<string>();

  uuids.forEach((uuid) => {
    uuid.groups_matched?.forEach((group) => {
      if (group) {
        groups.add(group);
      }
    });
  });

  return Array.from(groups);
}

export function shouldDisableAlternatives(groups: string[]): boolean {
  return groups.length > MAX_ALTERNATIVE_GROUPS;
}

export function shouldDisableAlternativesForFound(
  found: Record<string, AlternativeGroupMatch[] | boolean> | null | undefined
): boolean {
  return shouldDisableAlternatives(getUniqueAlternativeGroupsFromFound(found));
}

export function shouldDisableAlternativesForUuids(
  uuids: AlternativeUuidMatch[] | null | undefined
): boolean {
  return shouldDisableAlternatives(getUniqueAlternativeGroupsFromUuids(uuids));
}
